import { render, staticRenderFns } from "./card-widget.vue?vue&type=template&id=a1b53574&scoped=true&"
import script from "./card-widget.vue?vue&type=script&lang=js&"
export * from "./card-widget.vue?vue&type=script&lang=js&"
import style0 from "./card-widget.vue?vue&type=style&index=0&id=a1b53574&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b53574",
  null
  
)

export default component.exports